export default () => {
    const isiStatic = document.querySelector(".isi");
    const isiTray = document.querySelector(".isi-tray");
    const footer = document.querySelector(".footer");
    const body = document.querySelector("body");

    // Toggles ISI Tray open
    const toggle = document.querySelector(".isi-tray__toggle button");

    toggle.addEventListener("click", function(e) {
        e.preventDefault();
				//console.log('toggle');
        isiTray.classList.remove("open");
        isiTray.classList.toggle("expand");        
        body.classList.toggle("hidden");
    });

    let inFooter = false;

    // configure the intersection observer instance
    const intersectionObserverConfig = {
        // start fading out ISI Tray before or after target
				//bottom: -120px would mean target is showing 120px of content
        rootMargin: "0px 0px -120px 0px",
        ratio: 0,
    };

    function onIntersection(entries) {
        entries.forEach((entry) => {
            const { target, isIntersecting, intersectionRatio } = entry;

            // If static ISI is in the viewport, disable the ISI Tray
            if (
                target === isiStatic &&
                (isIntersecting || intersectionRatio > 0)
            ) {
                isiTray.classList.add("hidden");
                // If the footer is in the viewport, disable the ISI Tray
            } else if (
                target === footer &&
                (isIntersecting || intersectionRatio > 0)
            ) {
                isiTray.classList.add("hidden");
                inFooter = true;
                // If scrolling back up from the footer, keep ISI Tray disabled
            } else if (
                target === isiStatic &&
                inFooter &&
                (!isIntersecting || intersectionRatio === 0)
            ) {
                isiTray.classList.add("hidden");
                // If scrolling back up, we're no longer in the footer
            } else if (
                target === footer &&
                inFooter &&
                (!isIntersecting || intersectionRatio === 0)
            ) {
                inFooter = false;
                // Finally, if the Static ISI is not in view, then remove the ISI Tray
            } else if (
                target === isiStatic &&
                (!isIntersecting || intersectionRatio === 0)
            ) {
                isiTray.classList.remove("hidden");
            }
        });
    }

    // create observer instance
    const observer = new IntersectionObserver(
        onIntersection,
        intersectionObserverConfig
    );

    if (isiStatic && footer) {
        // provide the observer with a target
        observer.observe(isiStatic);
        observer.observe(footer);
    }
};
